import Chart from "react-apexcharts";
import { styled } from "@mui/material/styles";

export const MyChart = styled(Chart)``;
